(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["evolved-home-product-card"] && !Shopify.designMode) return;
  try {
    /* Variant thumbnails on product cards: update photo, prices and cart item. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ehc-var]');
    if (!btn || btn.disabled) return;
    var card = btn.closest('[data-ehc]');
    if (!card) return;
    card.querySelectorAll('[data-ehc-var]').forEach(function (b) {
      b.setAttribute('aria-checked', b === btn ? 'true' : 'false');
    });
    var d = btn.dataset;
    var id = card.querySelector('[data-ehc-id]');
    if (id) id.value = d.id;
    var plan = card.querySelector('[data-ehc-plan]');
    if (plan) { plan.value = d.plan || ''; plan.disabled = !d.plan; }
    var now = card.querySelector('[data-ehc-now]');
    if (now) now.textContent = d.now;
    var was = card.querySelector('[data-ehc-was]');
    var wasText = card.querySelector('[data-ehc-was-text]');
    if (was) { was.hidden = !d.was; if (wasText) wasText.textContent = d.was; }
    var save = card.querySelector('[data-ehc-save]');
    if (save) { save.hidden = !d.save; save.textContent = d.save; }
    var note = card.querySelector('[data-ehc-subnote]');
    if (note) note.hidden = d.sub !== 'true';
    var img = card.querySelector('[data-ehc-img]') || card.querySelector('.ehc__img:not(.ehc__img--hover)');
    if (img && d.img) { img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = d.img; }
  });

  /* Hover video: play muted on hover (mouse devices), pause and rewind on leave.
     Delegated, so it also works on carousel loop copies. */
  (function () {
    if (!window.matchMedia) return;
    var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    function videoOf(card) { return card ? card.querySelector('video.ehc__video') : null; }
    document.addEventListener('mouseover', function (e) {
      if (!fine.matches || reduce.matches) return;
      var card = e.target.closest && e.target.closest('.ehc--has-video');
      if (!card || (e.relatedTarget && card.contains(e.relatedTarget))) return;
      var vid = videoOf(card);
      if (!vid) return;
      vid.muted = true;
      var p = vid.play();
      if (p && p.catch) p.catch(function () {});
    });
    document.addEventListener('mouseout', function (e) {
      var card = e.target.closest && e.target.closest('.ehc--has-video');
      if (!card || (e.relatedTarget && card.contains(e.relatedTarget))) return;
      var vid = videoOf(card);
      if (!vid) return;
      vid.pause();
      try { vid.currentTime = 0; } catch (err) {}
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
